<template>
  <div v-if='detail' class='proDetail_box'>
    <div class='crumbs text_left'>
      <router-link to='/goods'>{{ $t('home.navigation.goods') }}</router-link>
      <span>/ {{ detail.goods_name }}</span>
    </div>
    <div class='pro_text'>
      <div class='goods_info fz_0'>
        <div v-if='detail.images && detail.images.length' id='goodsImage' class='swiper-container img_box dis_ib ver_m'>
          <div class='swiper-wrapper'>
            <div v-for='(item, index) in detail.images' :key='index' class='swiper-slide text_center'>
              <img class='goods-image' :src='item.image' alt='' />
            </div>
          </div>
          <div v-if='device === "mobile"' id='imgPagination' class='swiper-pagination'></div>
        </div>
        <dl class='dis_ib ver_m'>
          <dt>{{ detail.goods_name }}</dt>
          <dd>
            <div class='price'>{{ detail.market_price }}</div>
            <div class='tag'>
              <span v-for='(item, index) in detail.goods_tag' :key='index'>{{ item }}</span>
            </div>
          </dd>
        </dl>
      </div>
      <div v-if='detail.images && detail.images.length' class='pro_img fz_0'>
        <div v-for='(item, index) in detail.images' :key='index'
             class='pagination' :class='{active: index === activedIndex}'
             :style='thumbImageList[index]'
             @click.stop='slideTo(index)'
        >
        </div>
      </div>
    </div>
    <div v-if='descData' class='pro_info'>
      <img src='@/assets/icons/OvalCopy2@2x.png' width='230' height='230' alt='' class='bg1'>
      <div class='author_box'>
        <h4>
          <div v-if='descData.author.name'>{{ $t('goods.detail.author') }}：{{ descData.author.name }}</div>
          <div v-if='descData.drawer.name'>{{ $t('goods.detail.illustrator') }}：{{ descData.drawer.name }}</div>
        </h4>
        <div>
          <div v-for='(item, index) in descData.attr' :key='index'>{{ item.attr_name }}：{{ item.attr_value }}</div>
        </div>
      </div>
      <div class='info'>
        <html-content :html='descData.desc'></html-content>
      </div>
    </div>
    <div v-if='authorData && (authorData.author.author_name || authorData.author.author_name)' class='author_info pos_r'>
      <img src='@/assets/icons/Rectangle Copy 6@2x.png' width='294' height='294' alt='' class='bg2'>
      <img src='@/assets/icons/pen_bg2.png' width='295' height='152' alt='' class='bg3'>
      <h3 class='text_center'>{{ $t('goods.detail.author') }} & {{ $t('goods.detail.illustrator') }}</h3>
      <dl v-if='authorData.author.author_name'>
        <dt class='img_box'>
          <img v-if='authorData.author.author_avatar' :src='authorData.author.author_avatar' :alt='$t("goods.detail.author")' />
        </dt>
        <dd>
          <div class='name'>{{ $t('goods.detail.author') }}</div>
          <h4>{{ authorData.author.author_name }}</h4>
          <p>{{ authorData.author.author_desc }}</p>
        </dd>
      </dl>
      <dl v-if='authorData.drawer.author_name'>
        <dt class='img_box'>
          <img v-if='authorData.drawer.author_avatar' :src='authorData.drawer.author_avatar' :alt='$t("goods.detail.illustrator")' />
        </dt>
        <dd>
          <div class='name'>{{ $t('goods.detail.illustrator') }}</div>
          <h4>{{ authorData.drawer.author_name }}</h4>
          <p>{{ authorData.drawer.author_desc }}</p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import { getBookDetail, getBookDesc, getAuthor } from 'service'
import Swiper from 'swiper'
import HtmlContent from '@/components/HtmlContent'

export default {
  name: 'GoodsDetail',
  components: {
    HtmlContent,
  },
  data () {
    return {
      device: mediaDevice(),
      mySwiper: null,
      detail: null,
      descData: null,
      authorData: null,
    }
  },
  computed: {
    thumbImageList () {
      const list = []
      if (!this.detail.images) return list
      for (let item of this.detail.images) {
        list.push('background-image:url(' + item.thumb_image + ');background-size:100% auto;')
      }
      return list
    },
    activedIndex () {
      if (!this.mySwiper) return 0
      return this.mySwiper.activeIndex
    },
  },
  methods: {
    async init () {
      try {
        window.addEventListener('resize', () => {
          this.device = mediaDevice()
        })
        let query = this.$route.query
        await getBookDetail(query.id).then(res => {
          this.detail = res.data
          setTitle(`凯迪克图书 - ${this.detail.goods_name}`)
        })
        getBookDesc(query.id).then(res => {
          this.descData = res.data
        })
        getAuthor(query.id).then(res => {
          this.authorData = res.data
        })
        this.mySwiper = new Swiper('#goodsImage', {
          centeredSlides: true,
          slidesPerView: 'auto',
          pagination: {
            el: '#imgPagination',
          },
        })
      } catch (e) {
        alert(e.message)
        this.$router.push({ path: '/goods' })
      }
    },
    slideTo (index) {
      this.mySwiper.slideTo(index, 1000, false)
    },
  },
  mounted () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('goods.detail.title')}`)
    this.init()
  },
}
</script>
